import {QueryParamsEnum} from 'presentation/constants';
import {useEffect, useRef, useState} from 'react';
import {useDebounce} from 'presentation/hooks';
import {useQueryParams} from '../../hooks';

export function useFilters() {
	const {SEARCH_PARAMS, setSearchParams} = useQueryParams();
	const {query, shift} = SEARCH_PARAMS;

	const [searchValueState, setSearchValueState] = useState(query || '');
	const [filterValueState, setFilterValueState] = useState(shift || '');
	const [openDrawerState, setOpenDrawerState] = useState(false);

	const latestQueryRef = useRef(query);

	function handleShiftButton(shiftType: string) {
		setSearchParams(
			prev => {
				prev.set(QueryParamsEnum.SHIFT, shiftType);
				return prev;
			},
			{
				replace: true,
			},
		);
	}

	const [debouncedQueryFunc, abortDebounce] = useDebounce(() => {
		const currentQuery = latestQueryRef.current;
		if (currentQuery.length > 2) {
			setSearchValueState(currentQuery);
		}
	}, 500);

	function clearSearchParams() {
		setSearchValueState('');
		setSearchParams(
			prev => {
				prev.delete(QueryParamsEnum.SEARCH_QUERY);
				return prev;
			},
			{
				replace: true,
			},
		);
	}

	const handleConfirmShift = () => {
		handleShiftButton(filterValueState);
		handleCloseDrawer();
	};

	const handleClearFilters = () => {
		setFilterValueState('');
		setSearchParams(prev => {
			prev.delete(QueryParamsEnum.SHIFT);
			return prev;
		});
		setOpenDrawerState(false);
	};

	const handleOpenDrawer = () => {
		setOpenDrawerState(true);
	};

	const handleCloseDrawer = () => {
		setOpenDrawerState(false);
	};

	useEffect(() => {
		latestQueryRef.current = query;
	}, [query]);

	return {
		handleConfirmShift,
		handleClearFilters,
		handleOpenDrawer,
		handleCloseDrawer,
		filterValueState,
		openDrawerState,
		shift,
		setFilterValueState,
		searchValueState,
		debouncedQueryFunc,
		clearSearchParams,
		abortDebounce,
	};
}
